import dataApi from 'config/dataApi'

function deletePatient(patient, token) {
    const url = `${dataApi.api_url}delete_patient`
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization':token,
            },
            body: JSON.stringify(patient)
        }).then(response => response.json()).then(data => resolve(data))
    })
}
export default deletePatient